<template>
    <vReceivableComponent :postList="postList" v-if="flag"></vReceivableComponent>
</template>
<script>
import vReceivableComponent from '../../listComponent/basicdata/receivable/receivableComponent.vue';
export default {
    name: 'receivable',
    components: {
        vReceivableComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,

                date: true,
                rid: true,
                code: true,
                status:true,
                receivable_writeoff_status:true,
                supplier_rid: true,
                demander_rid: true,
                partner_rid: true,
                product_rid: true,
                person1_rid: true,
                person2_rid: true,
                promotion_type: true,
                ppa_code:true,

                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>